module.exports = __webpack_public_path__ + "img/facebook.7030afcf.svg";